/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {ChangeRequestSubscription} from '../models/ChangeRequestSubscription';
import type {Error} from '../models/Error';

export interface GetSubscriptionsByChangeRequestId$Request {
    changeRequestId: number;
}

export interface GetSubscriptionsByChangeRequestId$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSubscriptionsByChangeRequestIdRequest = createAction<PayloadData<void, GetSubscriptionsByChangeRequestId$Request>>('CHANGE_REQUEST_SUBSCRIPTION_CONTROLLER__GET_SUBSCRIPTIONS_BY_CHANGE_REQUEST_ID__REQUEST');
export const getSubscriptionsByChangeRequestIdSuccess = createAction<PayloadData<Array<ChangeRequestSubscription>, GetSubscriptionsByChangeRequestId$Request>>('CHANGE_REQUEST_SUBSCRIPTION_CONTROLLER__GET_SUBSCRIPTIONS_BY_CHANGE_REQUEST_ID__SUCCESS');
export const getSubscriptionsByChangeRequestIdFailure = createAction<PayloadData<Error, GetSubscriptionsByChangeRequestId$Request, true>>('CHANGE_REQUEST_SUBSCRIPTION_CONTROLLER__GET_SUBSCRIPTIONS_BY_CHANGE_REQUEST_ID__FAILURE');

export const getSubscriptionsByChangeRequestIdActions = [
    getSubscriptionsByChangeRequestIdRequest,
    getSubscriptionsByChangeRequestIdSuccess,
    getSubscriptionsByChangeRequestIdFailure
] as const;

/**
 * @param {number} meta.changeRequestId Change Request Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSubscriptionsByChangeRequestId = (meta: GetSubscriptionsByChangeRequestId$Request, config?: GetSubscriptionsByChangeRequestId$Config) => {
    return {
        CALL_API: {
            types: getSubscriptionsByChangeRequestIdActions,
            method: ApiMethods.GET,
            endpoint: `/change-request-subscriptions/${meta.changeRequestId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RemoveChangeRequestSubscriptionById$Request {
    id: number;
}

export interface RemoveChangeRequestSubscriptionById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeChangeRequestSubscriptionByIdRequest = createAction<PayloadData<void, RemoveChangeRequestSubscriptionById$Request>>('CHANGE_REQUEST_SUBSCRIPTION_CONTROLLER__REMOVE_CHANGE_REQUEST_SUBSCRIPTION_BY_ID__REQUEST');
export const removeChangeRequestSubscriptionByIdSuccess = createAction<PayloadData<void, RemoveChangeRequestSubscriptionById$Request>>('CHANGE_REQUEST_SUBSCRIPTION_CONTROLLER__REMOVE_CHANGE_REQUEST_SUBSCRIPTION_BY_ID__SUCCESS');
export const removeChangeRequestSubscriptionByIdFailure = createAction<PayloadData<Error, RemoveChangeRequestSubscriptionById$Request, true>>('CHANGE_REQUEST_SUBSCRIPTION_CONTROLLER__REMOVE_CHANGE_REQUEST_SUBSCRIPTION_BY_ID__FAILURE');

export const removeChangeRequestSubscriptionByIdActions = [
    removeChangeRequestSubscriptionByIdRequest,
    removeChangeRequestSubscriptionByIdSuccess,
    removeChangeRequestSubscriptionByIdFailure
] as const;

/**
 * @param {number} meta.id Change Request Subscription Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeChangeRequestSubscriptionById = (meta: RemoveChangeRequestSubscriptionById$Request, config?: RemoveChangeRequestSubscriptionById$Config) => {
    return {
        CALL_API: {
            types: removeChangeRequestSubscriptionByIdActions,
            method: ApiMethods.DELETE,
            endpoint: `/change-request-subscriptions/remove/${meta.id}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveChangeRequestSubscription$Request {
    changeRequestSubscription: ChangeRequestSubscription;
}

export interface SaveChangeRequestSubscription$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveChangeRequestSubscriptionRequest = createAction<PayloadData<void, SaveChangeRequestSubscription$Request>>('CHANGE_REQUEST_SUBSCRIPTION_CONTROLLER__SAVE_CHANGE_REQUEST_SUBSCRIPTION__REQUEST');
export const saveChangeRequestSubscriptionSuccess = createAction<PayloadData<number, SaveChangeRequestSubscription$Request>>('CHANGE_REQUEST_SUBSCRIPTION_CONTROLLER__SAVE_CHANGE_REQUEST_SUBSCRIPTION__SUCCESS');
export const saveChangeRequestSubscriptionFailure = createAction<PayloadData<Error, SaveChangeRequestSubscription$Request, true>>('CHANGE_REQUEST_SUBSCRIPTION_CONTROLLER__SAVE_CHANGE_REQUEST_SUBSCRIPTION__FAILURE');

export const saveChangeRequestSubscriptionActions = [
    saveChangeRequestSubscriptionRequest,
    saveChangeRequestSubscriptionSuccess,
    saveChangeRequestSubscriptionFailure
] as const;

/**
 * @param {ChangeRequestSubscription} meta.changeRequestSubscription
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveChangeRequestSubscription = (meta: SaveChangeRequestSubscription$Request, config?: SaveChangeRequestSubscription$Config) => {
    return {
        CALL_API: {
            types: saveChangeRequestSubscriptionActions,
            method: ApiMethods.POST,
            endpoint: `/change-request-subscriptions/save`,
            TRANSPORT_REQUEST_BODY: meta.changeRequestSubscription,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

